<template>
  <i-modal :title="LANG.archive" @openAutoFocus="fetchData">
    <template #default>
      <div id="archive_window_content">
        <ul
          ref="listview"
          class="archive-versions"
          style="max-height: 300px; overflow: auto; position: relative"
        >
          <li
            class="clearfix"
            v-for='(item, idx) in data'
            :key='idx'>
            <span class="archive_date i-col-sm-3">{{ localeDate(item.date) }} {{ item.finished ? `(${LANG.finished})` : '' }}</span>
              <i-button variant="secondary" @click.prevent="() => importVersion(item.arch_id)">{{ LANG.import }}</i-button>
              <i-button variant="secondary" @click.prevent="() => previewVersion(item.arch_id)">{{ LANG.preview }}</i-button>
          </li>
        </ul>
      </div>
    </template>
    <template #footer>
      <i-button
          variant="secondary"
          @click.prevent="$emit('update:show', false)"
        >
          {{ LANG.cancel }}
      </i-button>
    </template>
  </i-modal>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import fetchService from '@/utils/model/fetch_service';

import globals from '@/globals';

const { uri } = globals.I.Util;

export default defineComponent({
  props: {
    document: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data: () => ({
    data: [],
  }),
  computed: {
    ...mapState(['LANG', 'locale']),
    nodeId() {
      return this.document.node_id;
    },
  },
  methods: {
    async fetchData() {
      const response = await fetchService.GetData('docbrowser_archive_versions', { __imperia_node_id: this.nodeId });
      this.data = response.data;
    },
    importVersion(archId) {
      globals.context.open(uri('/document/archive/import', {
        __imperia_node_id: this.nodeId,
        __imperia_arch_id: archId,
        __imperia_method: 'edit',
      }), '_blank');
    },
    previewVersion(archId) {
      globals.context.open(uri('/document/preview', {
        __imperia_node_id: this.nodeId,
        __imperia_arch_id: archId,
      }), '_blank');
    },
    localeDate(timestamp) {
      const date = new Date(0);
      date.setUTCSeconds(timestamp);
      return date.toLocaleString(this.locale);
    },
  },
});
</script>

<style scoped lang='scss'>
.archive-versions {
  padding: 10px 0 10px 0;
  font-family: $font-family-regular;

  li {
    line-height: 55px;
    align-items: center;
    display: flex;
    align-content: center;
    justify-content: flex-start;
    border-bottom: 1px solid #f1eff0;
    margin-right: 15px;

    span {
      justify-self: flex-start;
      flex-grow: 1;
    }
  }
}
</style>
